import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import Auth from "../../Auth/Auth";
import ConfirmActions from "../../Action/Actions/ConfirmActions";
import Translator from "../../Translation/Translator";

export default function* resendConfirmationMail(action: ActionInterface): any {
  try {
    yield call(Auth.resendConfirmationMail, action.payload);

    // CASA-8583
    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("api-requst-confirm-email-sent"),
        type: "success"
      }
    });

    yield put({type: Constants.LOADING_HIDE});
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
    yield put(ConfirmActions.resendConfirmationMailFailure(err));
    yield put(ConfirmActions.openPopup(err.translatedMessage));
  }
}

export function* watchResendConfirmationMail() {
  yield takeEvery(Constants.PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_REQUEST, resendConfirmationMail);
}
